import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Field, Input } from '@/components/ui/Field';
import { useCreateCompany, useUpdateCompany } from '@/hooks/useApi';
import { toast } from '@/components/ui/Toast';
export function CompanyFormModal({ open, onClose, company }) {
    const { t } = useTranslation();
    const create = useCreateCompany();
    const update = useUpdateCompany();
    const [form, setForm] = useState({ name: '', percentageOff: 0, isActive: true });
    useEffect(() => {
        if (company)
            setForm({ name: company.name, percentageOff: company.percentageOff, isActive: company.isActive });
        else
            setForm({ name: '', percentageOff: 0, isActive: true });
    }, [company, open]);
    const submit = async () => {
        if (!form.name.trim()) {
            toast.error(t('common.name') + ' ' + t('common.submit'));
            return;
        }
        try {
            if (company)
                await update.mutateAsync({ id: company.id, ...form });
            else
                await create.mutateAsync(form);
            toast.success(t('common.save'));
            onClose();
        }
        catch (e) {
            toast.error(e?.response?.data?.error || 'خطا');
        }
    };
    return (_jsx(Modal, { open: open, onClose: onClose, title: company ? t('company.editCompany') : t('company.newCompany'), footer: _jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", onClick: onClose, children: t('common.cancel') }), _jsx(Button, { onClick: submit, loading: create.isPending || update.isPending, children: t('common.save') })] }), children: _jsxs("div", { className: "space-y-3", children: [_jsx(Field, { label: t('common.name'), children: _jsx(Input, { value: form.name, onChange: (e) => setForm({ ...form, name: e.target.value }) }) }), _jsx(Field, { label: t('company.discount'), children: _jsx(Input, { type: "number", min: 0, max: 100, step: 1, value: form.percentageOff, onChange: (e) => setForm({ ...form, percentageOff: Number(e.target.value) }) }) })] }) }));
}
